import React from 'react';
import { Card, CardContent } from '../ui/card';
import { ClipboardList, Edit, Ruler } from 'lucide-react';

const SurveyStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="shadow-lg border-0 bg-white/70 backdrop-blur-sm">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total Surveys</p>
              <p className="text-3xl font-bold text-gray-900">{stats?.total_surveys || 0}</p>
            </div>
            <div className="p-3 bg-[#8CB89F]/20 rounded-full">
              <ClipboardList className="h-6 w-6 text-[#8CB89F]" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="shadow-lg border-0 bg-white/70 backdrop-blur-sm">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Draft</p>
              <p className="text-3xl font-bold text-gray-600">{stats?.status_breakdown?.draft || 0}</p>
            </div>
            <div className="p-3 bg-gray-100 rounded-full">
              <Edit className="h-6 w-6 text-gray-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="shadow-lg border-0 bg-white/70 backdrop-blur-sm">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">In Progress</p>
              <p className="text-3xl font-bold text-[#8CB89F]">{stats?.status_breakdown?.in_progress || 0}</p>
            </div>
            <div className="p-3 bg-[#8CB89F]/20 rounded-full">
              <Ruler className="h-6 w-6 text-[#8CB89F]" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="shadow-lg border-0 bg-white/70 backdrop-blur-sm">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Completed</p>
              <p className="text-3xl font-bold text-green-600">{stats?.status_breakdown?.completed || 0}</p>
            </div>
            <div className="p-3 bg-green-100 rounded-full">
              <ClipboardList className="h-6 w-6 text-green-600" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SurveyStats;
